export default function Metric(props) {
  let celsTemp = Math.round(props.temp);
  return celsTemp;
}
